import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"fill-height backgroundLogin",style:({
    '--bg-color': _vm.isCE ? '#e0e0e0' : '#fff !important',
    '--bg-color-mobile': _vm.isCE ? 'var(--corPrimaria)' : '#fff !important',
  }),attrs:{"fluid":"","id":"login"}},[(_vm.isSala)?_c(VRow,[_c('login-selo',{scopedSlots:_vm._u([{key:"formulario",fn:function(){return [_c('login-form')]},proxy:true}],null,false,3851702602)})],1):(_vm.isCE || _vm.isDT || _vm.isTerritorio)?_c(VRow,[_c('LoginCE')],1):_c(VRow,[_c('GenericLogin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }